import React from 'react';
import { Icon } from '@scuf/common';
import './NotesIcon.scss';
import FontIcon from 'src/components/FontIcon/FontIcon';

export const NotesIcon = (params: any) => {
  return (
    <div onClick={() => params.clicked(params.data)}>
      <FontIcon iconName='fa-pen-to-square' className='pen-icon' iconSize='medium' />
    </div>
  );
};
